import { fetchVeiculosDestaque } from '../services/veiculos.js';

export async function renderPopulares() {
  const container = document.getElementById('cards-populares');
  if (!container) return;

  // Skeletons while loading
  container.innerHTML = Array(3).fill(
    '<div class="skeleton skeleton-card"></div>'
  ).join('');

  const { data: veiculos, error } = await fetchVeiculosDestaque().catch(() => ({ data: null, error: true }));

  const cars = (veiculos && veiculos.length > 0) ? veiculos.map(mapApiCar) : [];

  if (error && (!veiculos || !veiculos.length)) {
    console.warn('[populares] Nenhum dado retornado ou API indisponível.');
  }

  container.innerHTML = cars.length > 0 ? cars.map(cardPopularHTML).join('') : '';
}

/** Maps API vehicle row to a display-safe flat object for the popular card */
function mapApiCar(v) {
  const preco = v.preco_venda?.toLocaleString('pt-BR', { minimumFractionDigits: 0 }) ?? '—';
  const km = v.quilometragem?.toLocaleString('pt-BR') ?? '0';
  return {
    id: v.id,
    slug: v.slug,
    name: `${v.nome ?? ''} | ${v.ano_fabricacao ?? v.ano_modelo ?? '—'}  `.trim(),
    price: `R$ ${preco}`,
    meta: `${v.modelo ?? ''}`,
    badge: 'Destaque',
    badgeDark: false,
    img: v.foto_capa ?? 'https://images.unsplash.com/photo-1618843479313-40f8afb4b4d8?q=80&w=1000&auto=format&fit=crop',
    specs: [
      { label: v.combustivel ?? 'Combustível', icon: gasIcon() },
      { label: v.cambio ?? 'Câmbio', icon: gearIcon() },
      { label: `${km} km`, icon: kmIcon() },
    ],
    available: true,
  };
}

function cardPopularHTML(car) {
  return `
    <article class="card-popular" id="card-popular-${car.id}">
      <div class="card-popular-img-wrap">
        <img
          src="${car.img}"
          alt="${car.name}"
          class="card-popular-img"
          loading="lazy"
        />
        <span class="card-badge${car.badgeDark ? ' card-badge--dark' : ''}">${car.badge}</span>
      </div>

      <div class="card-header">
        <h3 class="card-name">${car.name}</h3>
        <span class="card-price${car.available ? '' : ' card-price--muted'}">${car.price}</span>
      </div>

      <p class="card-meta">${car.meta}</p>

      <div class="card-specs">
        ${car.specs.map(s => `
          <div class="card-spec">
            ${s.icon}
            <span class="card-spec-label">${s.label}</span>
          </div>
        `).join('')}
      </div>

      <div class="card-popular-actions" style="display: flex; gap: 0.5rem;">
        ${car.available 
          ? `<a href="/veiculo?slug=${car.slug || car.id}" class="btn btn-outline" style="flex: 1;" id="btn-detalhe-${car.id}">Ver detalhes</a>`
          : `<button disabled tabindex="-1" class="btn btn-disabled" style="flex: 1;" id="btn-detalhe-${car.id}">Indisponível</button>`
        }
      </div>
    </article>
  `;
}

/* ── SVG Icons ─────────────────────────────────────────────── */
function gasIcon() {
  return `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M14 11h1a2 2 0 0 1 2 2v3a1.5 1.5 0 0 0 3 0V9l-3-3"/><path d="M4 20V6a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v14"/><path d="M3 20h13"/><path d="M14 12H4"/></svg>`;
}
function gearIcon() {
  return `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>`;
}
function kmIcon() {
  return `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 12L8 8"/><path d="M12 7v1"/><path d="M17 12h-1"/><path d="M12 17v-1"/><path d="M7 12h1"/></svg>`;
}
